import { render } from "./EntrancePlantSettings.vue?vue&type=template&id=2d2f4681&ts=true"
import script from "./EntrancePlantSettings.ts?vue&type=script&lang=ts"
export * from "./EntrancePlantSettings.ts?vue&type=script&lang=ts"

import "./EntrancePlantSettings.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__